import React, { useEffect, useState } from "react";
import { AmericanFlagIcon, BenefitCheck } from "@/utils/miscIcons";
import Bars from "@/components/Bars";
import { useProductData } from "@/zustand/productStore.js";
import HeroSellingPoints from "@/components/ProductHeroContainer/HeroSellingPoints";
import RatingLine from "@/components/ProductHeroContainer/RatingLine";
import SocialMediaBanner from "@/components/ProductHeroContainer/SocialMediaBanner";
import SwiperGallery from "@/components/ProductHeroContainer/SwiperGallery";
import glideImage from "@/func/glideImage.js";
import OrderOverviewDrawerV3 from "@/components/orderSummary/OrderOverviewDrawerV3.jsx";

const ProductHeroSection = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const productData = useProductData();
  const heroContent = window.post_template.checkout_v4_product_hero;
  const flagIcon = glideImage(heroContent.checkout_v4_product_hero_flagIcon, { w: 32, h: 32, fit: "crop" });
  const backgroundColor = heroContent.checkout_v4_product_hero_background;
  const checkMarkFill = heroContent.checkout_v4_product_hero_checklistColor;
  const galleryBorderColor = heroContent.checkout_v4_product_hero_galleryBorder;
  const textColorPrimary = heroContent.checkout_v4_product_hero_textPrimary;
  const textColorFlag = heroContent.checkout_v4_product_hero_textFlag;
  const textColorSecondary = heroContent.checkout_v4_product_hero_textSecondary;
  const borderColor = heroContent?.checkout_v4_product_hero_socialsBorderColor;
  const complianceMode = false;
  const base = window.post_template;
  const orderSummaryVersion = base.checkout_v4_summary?.checkout_v4_summary_version;

  document.documentElement.style.setProperty("--gallery-border-color", galleryBorderColor);
  document.documentElement.style.setProperty("--hero-text-primary", textColorPrimary);
  document.documentElement.style.setProperty("--hero-text-flag", textColorFlag);
  document.documentElement.style.setProperty("--hero-text-secondary", textColorSecondary);

  const benefitsData = heroContent.checkout_v4_product_hero_benefits.map(
    (item) => item.tr_checkout_v4_product_herobenefit_title
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const CreateBenefits = () => {
    return benefitsData.map((benefit, index) => (
      <li key={index} className="productHero__benefits__item">
        <BenefitCheck fill={checkMarkFill} /> {benefit}
      </li>
    ));
  };

  return (
    <>
      {!orderSummaryVersion &&
        isMobile &&
        base.checkout_v4_product_hero.checkout_v4_product_hero_show &&
        base.checkout_v4_meta_bars?.checkout_v4_meta_bars_show && <Bars isProductHeroActive={true} />}
      <div
        className={`productHero__wrapper ${productData?.show_product_picker_v2 && "productHero__wrapper--productPickerV2"}`}
        style={{ background: backgroundColor, borderColor: borderColor }}
      >
        <div className="productHero__container">
          <div className="productHero__galleryWrapper">
            <SwiperGallery heroContent={window.post_template.checkout_v4_product_hero} />
          </div>
          {!complianceMode && (
            <div className="productHero__specialOffer hero-grid-column-2">
              {flagIcon ? (
                <img
                  className="productHero__flagIcon mon-img-32-w mon-img-32-h"
                  src={flagIcon}
                  alt={general_settings.brand_name}
                ></img>
              ) : (
                <AmericanFlagIcon />
              )}
              <span>{heroContent.tr_checkout_v4_flag_text}</span>
            </div>
          )}
          <div className="hero-grid-column-2">{!complianceMode && <RatingLine />}</div>
          <div className="productHero__heading hero-grid-column-2">{heroContent.tr_checkout_v4_product_hero_title}</div>
          <div className="productHero__description ProductHeroSection hero-grid-column-2">
            {heroContent.tr_checkout_v4_product_hero_description}
          </div>
          {benefitsData && (
            <ul className="productHero__benefits hero-grid-column-2" style={{ listStyleType: "none" }}>
              {CreateBenefits()}
            </ul>
          )}
          <div className="hero-grid-column-2">{!complianceMode && <SocialMediaBanner />}</div>
          <div className="hero-grid-column-2 hero-selling-points-tablet">
            <HeroSellingPoints />
          </div>
          {orderSummaryVersion && isMobile && <OrderOverviewDrawerV3 />}
          <div>
            {orderSummaryVersion &&
              isMobile &&
              base.checkout_v4_product_hero.checkout_v4_product_hero_show &&
              base.checkout_v4_meta_bars?.checkout_v4_meta_bars_show && <Bars isProductHeroActive={true} />}
          </div>
        </div>
      </div>
      <div className="productHero__bottomLine"></div>
    </>
  );
};

export default ProductHeroSection;
